import AttractionReservation, {
    AttractionReservationProps,
} from 'components/shared/AttractionReservation'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { SUNTAGO_BUS_PRICE } from 'constants/prices'
import { FormattedMessage } from 'react-intl'
import { useApp } from 'store/steps'
import cabanasImgMobile from 'assets/images/amenitiesAndAttractions/kabanyMobile.jpg'
//import memoryCaptureImgMobile from 'assets/images/amenitiesAndAttractions/memoryCaptureMobile.jpg'
import { useGetProductQuery } from 'store/api-slice/hooks'
import suntagoBusImgMobile from 'assets/images/amenitiesAndAttractions/suntagoBusMobile.jpg'
import { useAppSelector } from 'store/hooks'
import { useState } from 'react'
import { UpsellType } from 'store/upsell-slice'
import { CabanaType } from 'store/cabana-slice'
import { TransportType } from 'store/transport-slice'
import CabanaModal from 'routes/Upsell/CabanaModal'
import TransportModal from 'routes/Upsell/TransportModal'
import { CABANA_LOWEST_PRICE, CABANA_INCOMING_PRICE } from 'constants/prices'

const UpgradeAttractionRow = () => {
    const { language } = useApp()
    const {
        transport,
        cabanas,
        //memoryCapture,
    } = useAppSelector((state) => state.selfcare)

    const { data: cabanaData, isFetching: isCabanaFetching } =
        useGetProductQuery({
            _locale: language,
            productType: 'cabana',
        })

    const [isCabanaModalOpen, setIsCabanaModalOpen] = useState(false)
    const [isTransportModalOpen, setIsTransportModalOpen] = useState(false)

    const handleModalOpening = (
        upsellType: UpsellType | CabanaType | TransportType
    ) => {
        switch (upsellType) {
            case 'busTickets':
                setIsTransportModalOpen(!isTransportModalOpen)
                break
            case 'cabanas':
                setIsCabanaModalOpen(!isCabanaModalOpen)
                break
            //TODO: module disabled: ADDING NEW MEMORY CAPTURE
            // case 'memoryCapture':
            //     setIsCabanaModalOpen(!isCabanaModalOpen)
            //     break
            case undefined:
                break
        }
    }

    //const { data: memoryCaptureData } = useGetProductQuery({
    //    _locale: language,
    //    productType: 'memory_capture',
    //})

    const availableOnline: AttractionReservationProps[] = [
        {
            title: 'Suntago Bus',
            price: SUNTAGO_BUS_PRICE,
            isPriceFrom: true,
            images: suntagoBusImgMobile,
            upsellType: 'busTickets',
            stepToEditId: 'manage-transport',
            isActive: !!transport?.length,
        },
        {
            title: 'Cabana (16+)',
            price: cabanaData?.unitPrice || 0,
            otherPrice: CABANA_INCOMING_PRICE,
            lowestPrice: CABANA_LOWEST_PRICE,
            isPriceFrom: false,
            pricePer: 'couple',
            images: cabanasImgMobile,
            upsellType: 'cabanas',
            stepToEditId: 'manage-cabanas',
            isActive: !!cabanas?.length,
            isPriceLoading: isCabanaFetching,
        },
        // TODO: module disabled: ADDING NEW MEMORY CAPTURE
        //{
        //    title: 'Memory Capture',
        //    price: memoryCaptureData?.unitPrice,
        //    isPriceFrom: true,
        //    images: memoryCaptureImgMobile,
        //    upsellType: 'memoryCapture',
        //    stepToEditId: 'manage-memory-capture',
        //    isActive: !!memoryCapture?.length,
        //},
    ]

    const availableUpgrades = availableOnline.filter((item) => !item.isActive)

    return availableUpgrades.length > 0 ? (
        <>
            <Box isFullWidth id="upgrade-attraction-row">
                <Box
                    direction="row"
                    align="center"
                    justify="space-between"
                    isFullWidth
                    mb={[16, 24]}
                >
                    <Text variant="heading3" color="secondary_700">
                        <FormattedMessage
                            id="selfcare.upgrade_your_stay"
                            defaultMessage="Ulepsz swój pobyt!"
                        />
                    </Text>
                </Box>
                {availableUpgrades.map((item, index) => (
                    <AttractionReservation
                        key={index}
                        {...item}
                        handleModalOpening={handleModalOpening}
                    />
                ))}
            </Box>

            <CabanaModal
                isOpened={isCabanaModalOpen}
                closeModal={() => setIsCabanaModalOpen(!isCabanaModalOpen)}
            />
            <TransportModal
                isOpened={isTransportModalOpen}
                closeModal={() =>
                    setIsTransportModalOpen(!isTransportModalOpen)
                }
            />
        </>
    ) : null
}

export default UpgradeAttractionRow
